import { createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectServiceApi from "apis/ProjectServiceApi";
import { setProjectsList } from "./projectsList.slice";
import * as ProgramServiceApi from "apis/ProgramServiceApi";

  export const fetchProjectsByUserId = createAsyncThunk(
    "projects/projectsList/fetchByUserId",
    async (user_id: number, thunkAPI) => {
      try {
        const response = await ProjectServiceApi.getProjectByUser({ user_id });
        thunkAPI.dispatch(setProjectsList(response.data))
      } catch (error: any) {
        return thunkAPI.rejectWithValue(error.message || "Error fetching projects");
      }
    }
  );

  export const fetchProjectByProgramId = createAsyncThunk("projects/projectsList/fetchByProgramId",async (program_id:number,thunkAPI) => {
    try {
        const response = await ProgramServiceApi.getProgramByProgramId({ program_id});
        thunkAPI.dispatch(setProjectsList(response.projects));
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  })